var emptySdp =
  "v=0\n" +
  "o=fake 0 0 IN IP4 127.0.0.1\n" +
  "s=0\n" +
  "c=IN IP4 127.0.0.1\n" +
  "b=CT:64000\n" +
  "t=0 0\n" +
  "m=audio 1 RTP/AVP 0\n" +
  "a=rtpmap:0 PCMU/8000\n";

var SessionDescriptionHandlerNoWebRtc = {
  /**
   * Destructor
   */
  close: { value: function close() {} },

  /**
   * Gets the local description from the underlying media implementation
   * @param {Object} [options] Options object to be used by getDescription
   * @param {Array} [modifiers] Array with one time use description modifiers
   * @returns {Promise} Promise that resolves with the local description to be used for the session
   */
  getDescription: (options, modifiers) => {
    return new Promise(resolve => {
      resolve(emptySdp);
    });
  },

  /**
   * Check if the Session Description Handler can handle the Content-Type described by a SIP Message
   * @param {String} contentType The content type that is in the SIP Message
   * @returns {boolean}
   */
  hasDescription: contentType => {
    return true;
  },

  /**
   * The modifier that should be used when the session would like to place the call on hold
   * @param {String} [sdp] The description that will be modified
   * @returns {Promise} Promise that resolves with modified SDP
   */
  holdModifier: sdp => {
    return new Promise(resolve => {
      resolve();
    });
  },

  /**
   * Set the remote description to the underlying media implementation
   * @param {String} sessionDescription The description provided by a SIP message to be set on the media implementation
   * @param {Object} [options] Options object to be used by setDescription
   * @param {Array} [modifiers] Array with one time use description modifiers
   * @returns {Promise} Promise that resolves once the description is set
   */
  setDescription: (sessionDescription, options, modifiers) => {
    return new Promise(resolve => {
      resolve();
    });
  },
};

export default SessionDescriptionHandlerNoWebRtc;






// WEBPACK FOOTER //
// ./src/webrtc/sessionDescriptionHandlerNoWebRtc.js